import { faPlus, faSave, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { EstadoInterface, ReboqueInterface } from "../../../interfaces";
import React, { useRef } from "react";
import { getUuidV4, goToFocus, handleNumberOnly, isPlaca, upperCase, validarCPFCNPJ } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { addTracaoReboque, updateTracaoReboque } from "../../../features/manifestoSlice";

interface ReboqueFormProps {
    show: boolean,
    handleClose: () => void;
    form: ReboqueInterface;
    setForm: React.Dispatch<React.SetStateAction<ReboqueInterface>>
}

const initialForm: ReboqueInterface = {
    placa: '',
    tpCar: '00',
    uf: '',
    tara: 0,
    capKG: 0,
    capM3: 0,
    cint: '',
    id: 0,
    renavam: '',
    prop: false,
    prop_cpfcnpj: '',
    prop_rntrc: '',
    prop_xNome: '',
    prop_ie: '',
    prop_uf: '',
    prop_tpProp: 0,
}

const ReboqueForm: React.FC<ReboqueFormProps> = ({ show, handleClose, form, setForm }) => {
    const selectEstados = useSelector((state: RootState) => state.manifesto.selectEstados);
    const placaRef = useRef<HTMLInputElement>(null);
    const taraRef = useRef<HTMLInputElement>(null);
    const capRef = useRef<HTMLInputElement>(null);
    const ufRef = useRef<HTMLSelectElement>(null);
    const rnTrcRef = useRef<HTMLInputElement>(null);
    const nomeProprietarioRef = useRef<HTMLInputElement>(null);
    const ufProprietarioRef = useRef<HTMLSelectElement>(null);
    const cpfCnpjProprietarioRef = useRef<HTMLInputElement>(null);
    const codVeicRef = useRef<HTMLInputElement>(null);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.reboques);

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeCheckProp = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;

        if (!checked) {
            
            setForm({
                ...form,
                prop: false,
                prop_rntrc: '',
                prop_cpfcnpj: '',
                prop_ie: '',
                prop_tpProp: 0,
                prop_uf: '',
                prop_xNome: ''
            })

        } else {
            setForm({ ...form, prop: true })
        }

    }

    const validarCampos = () => {

        if (form.placa === "") {
            goToFocus(placaRef);
            alertModal('Informe a placa.');
            return false;
        }

        if (!isPlaca(form.placa)) {
            goToFocus(placaRef);
            alertModal('Placa inválida.');
            return false;
        }

        if (form.tara <= 0) {
            goToFocus(taraRef);
            alertModal('Informe a Tara(kg).');
            return false;
        }

        if (form.capKG <= 0) {
            goToFocus(capRef);
            alertModal('Informe a Capacidade(kg).')
            return false;
        }

        if (form.uf === '') {
            goToFocus(ufRef);
            alertModal('Informe a UF do reboque')
            return false;
        }

        if (form.prop) {

            if (form.prop_rntrc === '' || form.prop_rntrc === null || form.prop_rntrc === undefined) {
                goToFocus(rnTrcRef);
                alertModal('Informe o RNTRC')
                return false;
            }

            if (form.prop_uf === '') {
                goToFocus(ufProprietarioRef);
                alertModal('Informe a UF do proprietário')
                return false;
            }

            if (form.prop_xNome === "") {
                goToFocus(nomeProprietarioRef);
                alertModal('Informe o Nome do proprietário.')
                return false;
            }

            if (form.prop_cpfcnpj === "") {
                goToFocus(cpfCnpjProprietarioRef);
                alertModal('Informe o CPF/CNPJ do proprietário.')
                return false;
            }
            if (form.prop_uf === '') {
                goToFocus(ufProprietarioRef);
                alertModal('Informe a UF do proprietário.')
                return false;
            }

            if (!validarCPFCNPJ(form.prop_cpfcnpj || '')) {
                goToFocus(cpfCnpjProprietarioRef);
                alertModal('CPF/CNPJ inválido.');
                return false;
            }
        }

        return true;
    }
    const handleAdd = () => {

        if (validarCampos()) {
            if (lista.find((item: ReboqueInterface) => item.placa === form.placa)) {
                goToFocus(placaRef);
                alertModal('Reboque já adicionado com a placa ' + form.placa + '.')

            } else {

                dispatch(addTracaoReboque({
                    ...form,
                    id: getUuidV4()
                }))
                setForm(initialForm)
                handleClose();
            }
        }

    }

    const handleUpdate = () => {
        if (validarCampos()) {
            console.log(lista.find((item: ReboqueInterface) => item.placa === form.placa && item.id !== form.id))
            if (lista.find((item: ReboqueInterface) => item.placa === form.placa && item.id !== form.id)) {
                goToFocus(placaRef);
                alertModal("Roboque com a placa informada já foi adicionado.");
            } else {
                dispatch(updateTracaoReboque({
                    ...form,
                    id: form.id,
                    capKG: form.capKG,
                    capM3: form.capM3,
                    cint: form.cint,
                    placa: form.placa,
                    prop: form.prop,
                    prop_cpfcnpj: form.prop_cpfcnpj,
                    prop_ie: form.prop_ie,
                    prop_rntrc: form.prop_rntrc,
                    prop_tpProp: form.prop_tpProp,
                    prop_uf: form.prop_uf,
                    prop_xNome: form.prop_xNome,
                    renavam: form.renavam,
                    tara: form.tara,
                    tpCar: form.tpCar,
                    uf: form.uf

                }));
                setForm(initialForm);
                handleClose();
            }
        }
    }

    return (<Modal show={show} onHide={handleClose} centered backdrop='static' size="xl"
        fullscreen={'xl-down'} scrollable>
        <Modal.Header closeButton className={`py-2 `}>
            <Modal.Title>
                Reboque
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="g-2 mb-3">
                <Col md>
                    <Form.Group controlId="cint-reboque">
                        <Form.Label>Código do veículo</Form.Label>
                        <Form.Control name="cint" type="text"
                            value={form.cint}
                            ref={codVeicRef}
                            onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={10} />
                    </Form.Group>
                </Col>

                <Col md>
                    <Form.Group controlId="tpCar-reboque">
                        <Form.Label>Tipo Carroceria</Form.Label>
                        <Form.Select name="tpCar" onChange={handleChange}
                            value={form.tpCar}>
                            <option value="00">0 - Não Aplicável</option>
                            <option value="01">1 - Aberta</option>
                            <option value="02">2 - Fechada/Baú</option>
                            <option value="03">3 - Granelera</option>
                            <option value="04">4 - Porta Container</option>
                            <option value="05">5 - Sider</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md>
                    <Form.Group controlId="placa-reboque">
                        <Form.Label>* Placa</Form.Label>
                        <Form.Control name="placa" type="text" value={form.placa}
                            ref={placaRef}
                            onChange={handleChange} maxLength={7} onKeyUp={upperCase} />
                    </Form.Group>
                </Col>
                <Col md>
                    <Form.Group controlId="RENAVAM-reboque">
                        <Form.Label>RENAVAM</Form.Label>
                        <Form.Control name="renavam" type="text" value={form.renavam}
                            onChange={handleChange} maxLength={11} />
                    </Form.Group>
                </Col>
                <Col md={'auto'}>
                    <Form.Group controlId="uf-reboque">
                        <Form.Label>* UF</Form.Label>
                        <Form.Select name="uf" onChange={handleChange} ref={ufRef} value={form.uf}
                        >
                            {selectEstados?.map((estado: EstadoInterface) => {
                                return <option key={estado.id} value={estado.uf}>{estado.uf}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>

            </Row>

            <Row className="g-2 mb-3">
                <Col md>
                    <Form.Group controlId="tara-reboque">
                        <Form.Label>* Tara(kg)</Form.Label>
                        <Form.Control name="tara" type="text" min={0} value={form.tara}
                            ref={taraRef}
                            onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={6} />
                    </Form.Group>
                </Col>

                <Col md>
                    <Form.Group controlId="capKG-reboque">
                        <Form.Label>* Capacidade(kg)</Form.Label>
                        <Form.Control name="capKG" type="text" min={0} value={form.capKG}
                            ref={capRef}
                            onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={6} />
                    </Form.Group>
                </Col>

                <Col md>
                    <Form.Group controlId="capM3-reboque">
                        <Form.Label>Capacidade(M³)</Form.Label>
                        <Form.Control name="capM3" type="text" min={0} value={form.capM3}
                            onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={3} />
                    </Form.Group>
                </Col>

            </Row>

            <Row className="g-2 mb-3">
                <Col md >
                    <Form.Group >
                        <Form.Switch type="switch" checked={form.prop}
                            onChange={handleChangeCheckProp}
                            name="active" label="O proprietário não é emitente iniciado no aplicativo?" />
                    </Form.Group>
                </Col>

            </Row>

            {form.prop && (
                <>
                    <Row className="g-2 mb-3">
                        <Col md>
                            <Form.Group controlId="prop_rntrc">
                                <Form.Label>* RNTRC</Form.Label>
                                <Form.Control type="text" name="prop_rntrc"
                                    onChange={handleChange} value={form.prop_rntrc}
                                    ref={rnTrcRef}
                                    maxLength={8}
                                />
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group controlId="prop_tpProp">
                                <Form.Label>Tipo Proprietário</Form.Label>
                                <Form.Select name="prop_tpProp" value={form.prop_tpProp}
                                    onChange={handleChange} >
                                    <option value="0">0 - TAC Agregado</option>
                                    <option value="1">1 - TAC Independente</option>
                                    <option value="2">2 - Outros</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={'auto'}>
                            <Form.Group controlId="prop_uf">
                                <Form.Label>* UF</Form.Label>
                                <Form.Select name="prop_uf" value={form.prop_uf}
                                    ref={ufProprietarioRef}
                                    onChange={handleChange}>
                                    {selectEstados?.map((estado: EstadoInterface) => {
                                        return <option key={estado.id} value={estado.uf}>{estado.uf}</option>
                                    })}

                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="g-2 mb-3">
                        <Col md>
                            <Form.Group controlId="prop_xNome">
                                <Form.Label>* Nome do proprietário</Form.Label>
                                <Form.Control type="text" name="prop_xNome"
                                    value={form.prop_xNome} onChange={handleChange}
                                    ref={nomeProprietarioRef}
                                    maxLength={60}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group controlId="prop_cpfcnpj">
                                <Form.Label>* CPF/CNPJ</Form.Label>
                                <Form.Control type="text" name="prop_cpfcnpj" value={form.prop_cpfcnpj}
                                    ref={cpfCnpjProprietarioRef}
                                    onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={14} />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group controlId="ie-prop-reboque">
                                <Form.Label>Inscrição Estadual</Form.Label>
                                <Form.Control type="text" name="prop_ie" value={form.prop_ie}
                                    onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={14}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}

        </Modal.Body>
        <Modal.Footer className="py-1">
            <Button variant="danger" className="" onClick={handleClose} >
                <FontAwesomeIcon icon={faXmark} /> Cancelar
            </Button>

            {form.id === 0 ? (<>
                <Button variant="primary" className=" me-2" onClick={handleAdd} title="Adicionar">
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </>) : (<>
                <Button className=" me-2" variant="success" onClick={handleUpdate} title="Salvar">
                    <FontAwesomeIcon icon={faSave} /> Salvar
                </Button>
            </>)}
        </Modal.Footer>
        {ModalMessageEl}
    </Modal>)
}

export default ReboqueForm;